export enum LocationType {
  Country = 'country',
  ConstituentCountry = 'constituent_country',
  County = 'county',
  District = 'district',
  Region = 'region',
  City = 'city',
}

export enum CareType {
  All = 'all',
  CareHome = 'care_home',
  HomeCare = 'home_care',
  DementiaCareHome = 'care_home_dementia',
}

export const CareTypes = [
  CareType.All,
  CareType.CareHome,
  CareType.HomeCare,
  CareType.DementiaCareHome,
];

export enum ServiceType {
  Residential = 'residential',
  Nursing = 'nursing',
  Dementia = 'dementia',
  Palliative = 'palliative',
}

export interface SearchResponse {
  location?: string;
  regulator?: string;
  items?: any[];
  hasMoreResults?: boolean;
  totalCount?: number;
  req?: locationStatsRequestProps;
}

export interface TownStat {
  name: string;
  slug: string;
  count: number;
}

export interface locationStatsRequestProps {
  areaType?: string;
  location?: string;
  careType: string;
  geoPoint?: {
    lat: number;
    lon: number;
  };
  searchTerm?: string;
  filters?: any;
  page?: any;
}

export interface LocationsProps {
  careType?: CareType;
  data: {
    counts: {
      towns: { [key: string]: number };
      districts: { [key: string]: number };
      counties: { [key: string]: number };
      regions: { [key: string]: number };
      countries: { [key: string]: number };
    };
    countries: {
      name: string;
      slug: string;
      regions: {
        name: string;
        slug: string;
        counties: {
          name: string;
          slug: string;
          districts: {
            name: string;
            slug: string;
            towns: {
              name: string;
              slug: string;
            }[];
          }[];
          towns: {
            name: string;
            slug: string;
          }[];
        }[];
      }[];
    }[];
  };
}

export interface LocationID {
  areaType: LocationType;
  slug: string;
}

interface Point {
  lat: number;
  lon: number;
}

export interface LocationSummary extends LocationID {
  name: string;
  countsByCareType: { [careType: string]: number };
  countsByServiceType: { [serviceType: string]: number };
  countsByRating: { [serviceType: string]: number };
  belongsTo: { [key: string]: string };
  regulator?: string;
  centrePoint?: Point;
}

export const locationToSummary = (location: Location) => {
  const {
    areaType,
    slug,
    name,
    countsByCareType,
    countsByServiceType,
    countsByRating,
    belongsTo,
    regulator,
    centrePoint,
  } = location;

  return {
    areaType,
    slug,
    name,
    countsByCareType,
    countsByServiceType,
    countsByRating,
    belongsTo,
    regulator,
    centrePoint,
  } as LocationSummary;
};

export interface Location extends LocationSummary {
  name: string;
  countsByCareType: { [careType: string]: number };
  countsByServiceType: { [serviceType: string]: number };
  countsByRating: { [serviceType: string]: number };
  belongsTo: { [key: string]: string };
  contains: { [key: string]: string[] };
  regulator?: string;
  centrePoint?: Point;
  topTowns: { [key: string]: string[] | { [key: string]: string[] } };
  topDistricts: { [key: string]: string[] | { [key: string]: string[] } };
  nearby: { [key: string]: { [key: string]: string[] } };
  associated?: { [key: string]: LocationSummary };
}

export const locationIDRef = (id: LocationID) => {
  return `${id.areaType}/${id.slug}`;
};
